import { CartImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsCartCommerce {
    id?: string;
    revenue?: number;
    discount?: number;
    coupon?: string;
    item: GoogleAnalyticsProduct[];
}

export interface GoogleAnalyticsCartImpression
    extends GoogleAnalyticsMinimumDataset {
    commerce: GoogleAnalyticsCartCommerce;
    info: {
        name: string;
    };
}

const getGoogleAnalyticsCartImpression = (
    data: EnrichedAnalyticsEvent<CartImpressionTrackingInfo>
): GoogleAnalyticsCartImpression => {
    return {
        event: GoogleAnalyticsEvents.ProductCartView,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: data.payload.eventData.name
        },
        commerce: {
            revenue: data.payload.eventData.totalPrice,
            item: (data.payload.eventData.items || []).map((item) => {
                return {
                    ...getGoogleAnalyticsProduct(item),
                    quantity: item.quantity
                };
            })
        }
    };
};

export { getGoogleAnalyticsCartImpression };
